import React from "react";
import { PageHeader } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { MyProfileForm } from "@/components/MyProfileForm";
import { CareHomeProfileForm } from "@/components/CareHomeProfileForm";
import { ChampionSpotlightForm } from "@/components/ChampionSpotlightForm";

const SUBTITLE = {
  manager: "Your personal details, plus your care home's contact information and company logo. The logo appears on your Evidence Pack, Training Report and certificates.",
  staff: "Your personal details. Your courses and certificates live in their own tabs.",
  trainer: "Your personal details, Train the Trainer certification and the bio care homes see when booking sessions.",
  admin: "Your personal details.",
};

export default function Profile() {
  const { user } = useAuth();
  const refresh = () => window.dispatchEvent(new Event("care-home-updated"));
  const isManager = user.role === "manager";
  return (
    <div>
      <PageHeader title="My profile" subtitle={SUBTITLE[user.role] || SUBTITLE.staff} />
      <div className="bg-cream-card border border-cream-deep rounded-2xl p-6 md:p-8 max-w-3xl">
        <MyProfileForm onSaved={refresh} />
      </div>
      {isManager && (
        <>
          <div id="care-home-settings" className="bg-cream-card border border-cream-deep rounded-2xl p-6 md:p-8 max-w-3xl mt-6 scroll-mt-20">
            <h2 className="font-heading font-bold text-brand text-lg mb-5">Care home settings</h2>
            <CareHomeProfileForm getUrl="/care-home/profile" putUrl="/care-home/profile" logoUrl="/care-home/logo" onSaved={refresh} />
          </div>
          <div className="bg-cream-card border border-cream-deep rounded-2xl p-6 md:p-8 max-w-3xl mt-6">
            <ChampionSpotlightForm />
          </div>
        </>
      )}
    </div>
  );
}
